import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@modules/components/auth/auth.service';
import { UserRole } from '@shared/models/role';
import { AccountSwitchReason } from '@shared/services/account-switch/account-switch.enums';
import {
  buildAccountSwitchUrl,
  readSessionAccount,
} from '@shared/services/account-switch/account-switch.util';

export const newSubjectAccountGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const account = readSessionAccount(inject(AuthService).jwtToken);

  if (!account) {
    return true;
  }

  if (account.role !== UserRole.CLIENT) {
    return router.parseUrl(
      buildAccountSwitchUrl(AccountSwitchReason.ROLE, state.url),
    );
  }

  return true;
};
